<template><svg id="artwork" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 160">
  <g>
    <g>
      <polygon class="color-change" fill="#00b9ff"
               points="47.9 154.98 5.87 82.19 50.45 5.02 139.58 5.02 184.13 82.19 142.14 154.98 47.9 154.98"/>
      <path class="white" fill="#fff"
            d="M137,9.52l41.95,72.67-39.4,68.29h-89L11.07,82.19l42-72.67H137m5.19-9H47.86L.67,82.19,45.3,159.48h99.44l44.59-77.29L142.18.52Z"/>
    </g>
    <path id="Path_107" data-name="Path 107" class="white" fill="#fff"
          d="M127.91,65a32.81,32.81,0,0,1-8.14,21.66A53.47,53.47,0,0,0,110,103.93h-9v0a9,9,0,0,1,.41-2.67A59,59,0,0,1,113,80.77a23.94,23.94,0,1,0-36,0,59,59,0,0,1,11.63,20.51,9,9,0,0,1,.4,2.63v0H80a53.52,53.52,0,0,0-9.8-17.23A32.91,32.91,0,1,1,127.91,65ZM98,50.08a3,3,0,0,1-3,3h0A12,12,0,0,0,83,65a3,3,0,0,1-6,0,18,18,0,0,1,18-18,3,3,0,0,1,3,3ZM80,109.92H110V118a2.94,2.94,0,0,1-.5,1.65l-4.58,6.89a3,3,0,0,1-2.49,1.34H87.63a3,3,0,0,1-2.49-1.34l-4.58-6.89a2.94,2.94,0,0,1-.5-1.65Z"/>
  </g>
</svg>
</template>